import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Text } from '@rsos/components/capstone/base';
import onLogout from '@rsos/utils/onLogout';
import onSAMLrequest from '@rsos/utils/onSAMLrequest';
import { useLayoutContext } from '../base/Layout';
import {
  Backdrop,
  Link,
  AccessDeniedOverlayContent,
  TextExcerpt,
  FakeLink,
} from './AccessDenied.styles';
import { trackLogOutClick } from './accessDeniedTrackings';

const AccessDenied = ({ handleAccessDeniedLink = null, height, persistor }) => {
  const { layout } = useLayoutContext();
  const dispatch = useDispatch();
  const { sinatra } = useSelector(state => state);
  const isLoadingSAML = sinatra.auth.loadingSAML;
  const currentApp = sinatra.user.currentRole.application;
  const irpVersion = sinatra.irp.irpVersion;

  const handleRefresh = () => {
    window.location.reload();
  };
  const handleLogout = () => {
    trackLogOutClick(currentApp, irpVersion);
    return onLogout(persistor, dispatch);
  };
  const handleSAMLRequest = () => {
    return onSAMLrequest('support', dispatch, isLoadingSAML, persistor);
  };

  const linkDiv = !handleAccessDeniedLink ? (
    <Link href="/admin/psap#boundary-upload">here</Link>
  ) : (
    <Box cursor="pointer" inline onClick={handleAccessDeniedLink}>
      <Link>here</Link>
    </Box>
  );

  return (
    <Backdrop
      data-name="access-denied-overlay"
      height={height || layout.body.height}
    >
      <AccessDeniedOverlayContent>
        <Box flow={10} my={10}>
          <TextExcerpt>
            Whoops, looks like your agency doesn't have access to this page yet.
          </TextExcerpt>
          <TextExcerpt>
            If you are an admin, please make sure your agency's jurisdictional
            boundary has been submitted {linkDiv}.
          </TextExcerpt>
          <TextExcerpt>
            If you've already submitted your jurisdictional boundary, please
            hang tight. The process to get data flowing can take up to 4 weeks.
            If it's been more than 4 weeks, or you have any other questions,
            please submit a ticket via{' '}
            <Text inline>
              <FakeLink type="primary" onClick={handleSAMLRequest}>
                “support”
              </FakeLink>
            </Text>
          </TextExcerpt>
        </Box>
      </AccessDeniedOverlayContent>
      <Box horizontal flow={7}>
        <Button btnType="primary" onClick={handleRefresh}>
          Refresh
        </Button>
        <Button btnType="tertiary" onClick={handleLogout}>
          Log out
        </Button>
      </Box>
    </Backdrop>
  );
};

export default React.memo(AccessDenied);
